module.exports = __webpack_public_path__ + "img/triumph.5b59da1a.png";